import { h } from "preact";
import { msg, t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MobilePage from "../../../jamibet/utils/mobile-page";
import Page from "../../../../services/page-data-feed";
import Session from "../../../jamibet/utils/session";
import { CloseIconSlim } from "../../../jamibet/mobile-templates/general";
import VisibleOnHash from "../../../jamibet/utils/hash-popup";
import AwrabetPopupLogin from "../../../awrabet/mobile-components/site/popup-login";
import User from "../../../../services/user";
import Config from "../../config";
import { TelegramButton } from "../../../../services/telegram/openidLogin";
import { FacebookIcon } from "../../../awrabet/utils/icons";
import { TelegramPlaneIcon } from "../../utils/icons";

export default class PopupLogin extends AwrabetPopupLogin {
	state = { error: false, errorMessage: "", step: 'login', credentials: null, sending: false };

	async login() {
		this.setState({ sending: true, error: false });
		const loginForm = new FormData(this.form);
		const username = loginForm.get('username');
		const password = loginForm.get('password');
		try {
			await Session.loginPromise(username, password);
			this.setState({ error: false, errorMessage: "", sending: false });
			MobilePage.closeHashPopup();
			Page.rerender();
		} catch (err) {
			if (err.error === 'link-sent') {
				this.setState({ step: 'otp', credentials: { username, password }, error: false, errorMessage: "", sending: false });
			} else {
				this.setState({ error: true, errorMessage: err.error || err.msg || err, sending: false });
			}
		}
	}

	async handleOtpSubmit() {
		this.setState({ sending: true, error: false });
		const otpForm = new FormData(this.form);
		const otp = otpForm.get('otp');
		try {
			await User.firstLoginVerifyOTP(otp, this.state.credentials.username, this.state.credentials.password);
			this.setState({ step: 'final', sending: false });
			setTimeout(() => { MobilePage.closeHashPopup(); Page.rerender(); }, 2000);
		} catch (err) {
			this.setState({ error: true, errorMessage: err.error || err, sending: false });
		}
	}

	renderLoginForm() {
		return (
			<form class="fn-login-form" ref={ref => this.form = ref} onSubmit={e => { e.preventDefault(); this.login() }}>
				<div class="px-4 pb-1 pt-3 text-lg"><Trans>Login</Trans></div>
				<div class="p-2">
					<div class="mob-panel-row p-2">
						<div class="text-sm"><Trans>Login</Trans></div>
						<div class="pt-1 relative">
							<div class="absolute text-xs top-0 bottom-0 flex items-center pl-1 pt-1 bg-transparent text-slate-950">+251 (0)</div>
							<input class="w-full rounded-sm bg-white px-2 py-1 text-black disabled:bg-blue-whale-600 disabled:text-white pl-12"
								name="username" autocomplete="username" />
						</div>
					</div>
					<div class="mob-panel-row p-2">
						<div class="text-sm"><Trans>Password</Trans></div>
						<div class="pt-1">
							<input class="w-full rounded-sm bg-white px-2 py-1 text-black disabled:bg-blue-whale-600 disabled:text-white"
								type="password" name="password" autocomplete="current-password" />
						</div>
					</div>
				</div>
				{this.renderError()}
				<div class="p-2 px-4">
					<button type="submit" disabled={this.state.sending}
						class="w-full rounded bg-custom-orange py-2 text-center text-lg text-black disabled:opacity-50">
						{this.state.sending ? <Trans>Loading...</Trans> : <Trans>Login</Trans>}
					</button>
					<a class="block mt-6 px-3 text-center text-sm" href="#recovery"><Trans>Forgot your password?</Trans></a>
				</div>
			</form>
		);
	}

	renderOtpForm() {
		return (
			<form class="fn-otp-form" ref={ref => this.form = ref} onSubmit={e => { e.preventDefault(); this.handleOtpSubmit() }}>
				<div class="px-4 pb-1 pt-3 text-lg"><Trans>Verify OTP</Trans></div>
				<div class="p-4 text-sm text-center"><Trans>We have sent you an SMS with a verification code.</Trans></div>
				<div class="p-2">
					<div class="mob-panel-row p-2">
						<div class="text-sm"><Trans>OTP Code</Trans></div>
						<div class="pt-1">
							<input class="w-full rounded-sm bg-white px-2 py-1 text-black disabled:bg-blue-whale-600 disabled:text-white"
								name="otp" autocomplete="one-time-code" inputmode="numeric" />
						</div>
					</div>
				</div>
				{this.renderError()}
				<div class="p-2 px-4">
					<button type="submit" disabled={this.state.sending}
						class="w-full rounded bg-custom-orange py-2 text-center text-lg text-black disabled:opacity-50">
						{this.state.sending ? <Trans>Verifying...</Trans> : <Trans>Verify</Trans>}
					</button>
				</div>
			</form>
		);
	}

	renderFinalStep() {
		return (
			<div class="p-4 text-center">
				<div class="px-4 pb-1 pt-3 text-lg"><Trans>Login Successful</Trans></div>
				<div class="p-4 text-sm"><Trans>You will be logged in shortly.</Trans></div>
			</div>
		);
	}

	renderError() {
		if (!this.state.error) return null;
		let errorMessage = this.state.errorMessage;
		if (errorMessage === 'login-wrong-otp') errorMessage = <Trans>The entered OTP is incorrect.</Trans>;
		else if (errorMessage === 'login-wrong-credentials') errorMessage = <Trans>Incorrect username or password.</Trans>;
		return (
			<div class="fn-error-message">
				<div class="w-full px-2 text-center pt-3 mb-2">
					<div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
						<div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
						<span>{errorMessage}</span>
					</div>
				</div>
			</div>
		);
	}

	render() {
		let content;
		switch (this.state.step) {
			case 'otp': content = this.renderOtpForm(); break;
			case 'final': content = this.renderFinalStep(); break;
			case 'login':
			default: content = this.renderLoginForm(); break;
		}

		return (
			<VisibleOnHash id="login-page" class={"fixed z-10 inset-0 overflow-y-auto text-white backdrop-blur-sm"} hash="#login">
				<div class="absolute top-0 right-0 w-12 p-3 fn-close" onClick={e => MobilePage.closeHashPopup()}>
					<CloseIconSlim />
				</div>
				<div class="pl-12 h-full">
					<div class="flex h-full flex-col bg-harif-800 text-white">
						{content}

						{!!Config.telegramLogin && <>
							<div class="relative flex justify-center px-4 pt-8 pb-2 text-center">
								<div class="absolute bottom-4 left-4 right-4 border-b"></div>
								<div class="z-0 bg-harif-800 px-4 text-sm"><Trans>Oppure</Trans></div>
							</div>
							<div class="px-4">
								<TelegramButton
									class="w-full"
									clientId={Config.telegramLogin}
									text={t`Login via Telegram`}
									shape="square"
									iconOnly={false}
									onSuccess={e => { MobilePage.closeHashPopup(); Page.rerender(); }}
								/>
							</div>
							<div class="flex flex-col items-center gap-2 pt-3 pb-1">
								<span class="text-xs text-gray-400"><Trans>Follow us on</Trans></span>
								<div class="flex justify-center gap-3">
									<a href="https://www.facebook.com/share/1JDABF5wJv/" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-gray-300 transition-colors">
										<FacebookIcon class="w-6 h-6 fill-current" />
									</a>
									<a href="http://t.me/gojjobet" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-gray-300 transition-colors">
										<TelegramPlaneIcon class="w-6 h-6" />
									</a>
								</div>
							</div>
						</>}

						<div class="grow"></div>
						<div class="bg-harif-900 px-2 py-2">
							<div class="py-1 text-center">
								<Trans>Create an account</Trans>
								<a class="border-b border-custom-orange-dark pb-0.5 px-0.5 text-custom-orange-dark" href="#register">
									<Trans>Register</Trans>
								</a>
							</div>
							<div class="py-1 text-center text-sm"><Trans>Login to place bets</Trans></div>
						</div>
					</div>
				</div>
			</VisibleOnHash>
		);
	}
}
